module.exports = __webpack_public_path__ + "static/media/karachi-dha.9cc739fe.svg";